import WebsiteBehaviors from "../website-behaviors/index.js";
import Selection from "../selection.js";
import {triggerEvent} from "../utils/document.js";
import Citation from "../citation.js";

class ProQuestEbooks extends WebsiteBehaviors {
	identifier() {
		return "ProQuestEbooks";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "ebookcentral.proquest.com" || location.host.endsWith(".ebookcentral.proquest.com"));
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'annotation' implicitly has an 'any' typ... Remove this comment to see the full error message
	alterNewHighlight(annotation) {
		const {content, pageId} = (document.body as any).PnSelectionData;

		// TODO: Fill divs for pages previous to the one we want. Then, use Selection.GetSelectionFromRange() to
		// create the annotation object, not from a real text selection, but directly from the id of the page.
		// for (let i = 1; i < page; i++) {
		//
		// }
		const range = document.createRange();
		// @ts-expect-error TS(2345) FIXME: Argument of type 'Element | null' is not assignabl... Remove this comment to see the full error message
		range.selectNodeContents(document.querySelector(`#${pageId} img`));

		annotation.selection = Selection.GetSelectionFromRange(range);
		annotation.selectedText = content;
	}

	// @ts-expect-error TS(2416) FIXME: Property 'mouseUp' in type 'ProQuestEbooks' is not... Remove this comment to see the full error message
	async mouseUp(event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy) {
		const copyButton = document.querySelector(".popover #contextCopy");
		if (!copyButton)
			return false;

		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		const pageId = copyButton.closest(".mainViewerImgContainerParent").id;

		const hideModalStyles = document.createElement("style");
		hideModalStyles.innerText = ""
			+ ".modal-backdrop, .modal {display: none !important}"
			+ "body {padding-right: 0 !important;}";
		document.documentElement.append(hideModalStyles);
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		document.getElementById("contextCopy").click();

		// @ts-expect-error TS(7006) FIXME: Parameter 'resolve' implicitly has an 'any' type.
		const intervalHandler = function (resolve) {
			const copyContent = document.querySelector(".modal.in #copyContent");
			if (!copyContent)
				return;

			let content = "", citation = ""; // Placeholders for the two values we care about

			// do something like this, basically: copyContent.text().split('\n');
			const lines = copyContent.innerHTML
				.split("<br>")
				.map(line => line.replace(/<[^>]+>/g, ""));

			// We expect the content (could be multiple lines), then citation, then a line with stuff we don't care about
			if (lines.length >= 3) {
				content = lines.slice(0, -2).join("\n");
				citation = lines[lines.length - 2];
			} else {
				// If we don't have what we expect, just put everything as "content", and no citation
				content = lines.join("\n");
			}

			// Clean-up
			// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
			document.getElementById("modalCancel").click();
			setTimeout(function () {
				document.documentElement.removeChild(hideModalStyles);
			}, 500);

			if (content !== "") {
				(document.body as any).PnSelectionData = {content, citation, pageId};

				// Set page override (URL including page number)
				const pageData = page.getPageData();
				triggerEvent(document, "#toolLink", "click");
				if (document.getElementById("shareUrl")) {
					const url = (document.getElementById("shareUrl") as any).value;
					pageData.pageUrl = processOrgProxy(url);
				}
				// @ts-expect-error FIXME
				const bookTitle = (document.querySelector("#closeMetaData .book-title")).innerText.trim();
				if (bookTitle)
					pageData.pageTitle = bookTitle;
				triggerEvent(document, "#shareBookLink button.btn-close", "click");
				page.setPageDataOverride(pageData);

				resolve(true);
			} else
				resolve(false);
		};

		return await new Promise(resolve => {
			// eslint-disable-next-line prefer-const
			let interval: NodeJS.Timeout;
			// @ts-expect-error TS(7006) FIXME: Parameter 'result' implicitly has an 'any' type.
			const resolveAndClearInterval = result => {
				resolve(result);
				clearInterval(interval);
			};
			interval = setInterval(() => intervalHandler(resolveAndClearInterval), 100);
		});
	}

	getCopyButtonLabel() {
		return "Copy With Citation";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'selectedText' implicitly has an 'any' t... Remove this comment to see the full error message
	async copySelectionToClipboard(selectedText, document, loadCitation) {
		const {citation, content} = document.body.PnSelectionData;

		selectedText = (content + "\n\n" + citation).trim();

		super.copySelectionToClipboard(selectedText, document, loadCitation);
	}

	async generateStructuredCitation() {
		// Get document ID
		const url = window.location.href;
		const documentUrl = new URL(url);
		const docId = documentUrl.searchParams.get("docID");
		if (!docId)
			return null;

		// Get first part of URL, which differs based on the institution
		const regExp = /.+?(?=\/reader.action)/;
		const match = regExp.exec(url);
		if (!match)
			return null;

		// Get RIS from their citation API
		const citationUrl = new URL(`${match[0]}/biblioExport.action?docID=${docId}`);

		const response = await fetch(citationUrl);
		if (response.status !== 200)
			return null;

		const ris = await response.text();

		return Citation.fromRIS(ris);
	}
}

export default ProQuestEbooks;
